'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = fetchEntity;

var _effects = require('redux-saga/effects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchEntity);

/**
 * Reusable fetch Subroutine
 * @param {object} entity - object with the respective actions for a fetch flow: request, success...
 * @param {function} apiFn - method which execute the fetch call
 * @param params - rest of the params and data which are going to be sent to the fetch request
 */
function fetchEntity(entity, apiFn) {
  var _len,
      params,
      _key,
      response,
      _args = arguments;

  return _regenerator2.default.wrap(function fetchEntity$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(entity.request());

        case 2:
          _context.prev = 2;

          for (_len = _args.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            params[_key - 2] = _args[_key];
          }

          _context.next = 6;
          return _effects.call.apply(undefined, [apiFn].concat(params));

        case 6:
          response = _context.sent;
          _context.next = 9;
          return (0, _effects.put)(entity.success(response));

        case 9:
          return _context.abrupt('return', response);

        case 12:
          _context.prev = 12;
          _context.t0 = _context['catch'](2);
          _context.next = 16;
          return (0, _effects.put)(entity.failure(_context.t0));

        case 16:
          throw _context.t0;

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[2, 12]]);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/utils/fetchEntitySaga.js
// module id = 354
// module chunks = 0